import React, { useState, useContext } from "react";
import { myPurchaseGet, oppMatchesGet, userGet, purchaseDelete, oppMatchesDelete } from '../../../api';
import Loading from '../../Loading';
import { UserContext } from "../../../context/User";
import { useHistory } from 'react-router';
import { somethingWentWrongNotice } from '../../UI/Notifications';
import { Container, Row, Col } from "react-bootstrap";
import AlertMessage from "../../AlertMessage";
import QuickStats from "./QuickStats";
import Support from './Support';
import RecentRegistrations from './RecentRegistrations';
import DashboardBanner from "components/UpdateDashboardMessage/DashboardBanner";

const EDIT_MATCHES_ALERT = `
  <div>
    <h6 class="mb-0">Admin Message</h6>
    <p class="mb-0">
      The MatchForce system will run it's matching algorithm every 2 hours. If you make changes to your profile information and are <br /> 
      expecting new matches to appear, please be sure to wait the 2 hours before looking again
    </p>
  </div> 
`;

const AdminDashboard = () => {
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  
  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Dashboard");
    }
    setLoading(false);
  }

  return (
    <section className="section-spaces">
      <Container>
        <Row>
          <Col>
            <h3 className="mb-5">
              Admin Dashboard
            </h3>
            <DashboardBanner />  
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            <QuickStats />
            <Support />
          </Col>
          <Col lg={6}>
            <RecentRegistrations 
              setLoading={setLoading}
              handleDefaultStatusCodes={handleDefaultStatusCodes}
            />
          </Col>
        </Row>
      </Container>
    {loading && <Loading />}
    </section>
  )
}

export default AdminDashboard;
